import React, { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import {
  Grid, Typography, Button, IconButton,
  TextField, FormControl, InputLabel, FilledInput, Select, MenuItem,
  List, ListItem, ListItemText,
  Dialog, DialogTitle, DialogContent,
  Tooltip, Paper, Popover
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import TreeView from '@material-ui/lab/TreeView'

import StyleIcon from '@material-ui/icons/Style'
import CloseIcon from '@material-ui/icons/Close'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'

import { ValidateEmail, ValidatePhone, adminUpdateUserPassword, handleTextPrepper, keyify2, handlePhonePrepper } from './../../../../utils'
import { statusTypes, statusPermissions } from '../../../../utils/variables'

import { PhoneMask, EmailMask } from '../../tools/TextMasks'

import { NotificationToast } from '../../tools/Toast'

import { getRoleSupervisors, createNewSupervisor, updateExistingSupervisor, deleteExistingSupervisor } from '../../../../redux/actions'

import ResetPassword from '../../modals/ResetPassword'
import UnitTree from '../../tools/UnitTree'
import { ConfirmToast } from '../../tools'

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

const useSelectStyles = makeStyles((theme) => ({
  select: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    '&:focus': {
      backgroundColor: '#f5f5f5'
    },
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  }
}))

const useStyles = makeStyles((theme) => ({
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  roleBtn: {
    paddingLeft: '0.5em',
    paddingRight: '0.5em'
  },
  errorLight: {
    backgroundColor: '#f0ad4e',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#BD7A1B'
    }
  },
  successLight: {
    backgroundColor: '#719E31',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#3E6B00',
      color: '#fff'
    }
  },
  selectedRole: {
    color: '#719E31'
  },
  unselectedRole: {
    color: theme.palette.text.secondary
  },
  ouBtn: {
    paddingLeft: '0.5em',
    paddingRight: '0.5em'
  },
  ouPopper: {
    zIndex: '1051 !important',
    marginBottom: theme.spacing(1)
  },
  ouPaper: {
    padding: theme.spacing(1),
    width: '100%',
    height: 'fit-content'
  }
}))

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

// const StyledSwitch = withStyles({
//   switchBase: {
//     color: 'white',
//     '&$checked': {
//       color: '#A4D164'
//     },
//     '&$checked + $track': {
//       backgroundColor: '#A4D164'
//     }
//   },
//   checked: {},
//   track: {}
// })(Switch)

const UserMgmtUserMOD = (props) => {
  const {
    firstName, lastName, jobTitle, cellPhone, emailAddress, roleID, units,
    MODsupervisorID, onBackTrack, onSuccess,
    roles, userRoles, type
  } = props

  const textClasses = useTextStyles()
  const selectClasses = useSelectStyles()
  const classes = useStyles()
  const dispatch = useDispatch()

  const { supervisorID, token, accountId, unitTree, isSSO = false } = useSelector(state => state.auth)

  const [firstNameMOD, setFirstNameMOD] = useState(firstName)
  const [lastNameMOD, setLastNameMOD] = useState(lastName)
  const [jobTitleMOD, setJobTitleMOD] = useState(jobTitle == null ? '' : jobTitle)
  const [cellPhoneMOD, setCellPhoneMOD] = useState(cellPhone == null ? '' : cellPhone)
  const [emailAddressMOD, setEmailAddressMOD] = useState(emailAddress)
  const [roleMOD, setRoleMOD] = useState(roleID)
  const [unitsMOD, setUnitsMOD] = useState(units)
  // const [roleNameMOD, setRoleNameMOD] = useState(roleName)

  const [passwordModal, setPasswordModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [openRoles, setOpenRoles] = useState(false)
  const [expandedKeys] = useState(keyify2(unitTree))

  const [roleChangeWarning, setRoleChangeWarning] = useState(false)

  const [roleChangeAnchorEl, setRoleChangeAnchorEl] = useState(null)

  const handleRoleChangePopClose = () => {
    setRoleChangeAnchorEl(null)
  }
  const openRoleChangeAnchor = Boolean(roleChangeAnchorEl)

  const fireCreateSuccess = (previousSupervisorBool) => {
    dispatch(getRoleSupervisors())
    NotificationToast(false, `Success!${!previousSupervisorBool ? ' The user will receive an email asking them to create a new password.' : ''}`)
    onSuccess()
  }

  const fireCreateFailure = (resCode) => {
    let message = 'Failed to create new user!'
    if (resCode === 409) { message = 'User Already Exists!' }
    NotificationToast(true, message)
  }

  const fireDeleteSuccess = () => {
    dispatch(getRoleSupervisors())
    NotificationToast(false, 'Successfully deleted supervisor!')
    onSuccess()
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to delete supervisor!')
  }

  const fireEditSuccess = (permissionsChanged) => {
    if (permissionsChanged) { setRoleChangeWarning(false); handleRoleChangePopClose() }

    dispatch(getRoleSupervisors())
    NotificationToast(false, 'Successfully updated supervisor!')
    onSuccess()
  }

  const fireEditFailure = () => {
    NotificationToast(true, 'Failed to update supervisor!')
  }

  const confirmSaveUser = (isNewUser, isChangingRole, removingUnits = false) => {
    const selectedUser = {
      firstName: handleTextPrepper(firstNameMOD),
      lastName: handleTextPrepper(lastNameMOD),
      jobTitle: handleTextPrepper(jobTitleMOD),
      officePhone: cellPhoneMOD && cellPhoneMOD !== '' ? handlePhonePrepper(cellPhoneMOD) : '',
      roleID: roleMOD,
      units: unitsMOD,
      unitAccessRevoked: removingUnits
    }

    let dispatchInfo = null

    if (isNewUser) {
      selectedUser.emailAddress = handleTextPrepper(emailAddressMOD)
      dispatchInfo = { action: createNewSupervisor, fireSuccess: fireCreateSuccess, fireFailure: fireCreateFailure }
    } else {
      selectedUser.targetID = MODsupervisorID
      dispatchInfo = { action: updateExistingSupervisor, fireSuccess: () => fireEditSuccess(isChangingRole), fireFailure: fireEditFailure }
    }

    if (dispatchInfo && Object.entries(dispatchInfo).length > 0) {
      dispatch(dispatchInfo?.action(selectedUser, dispatchInfo?.fireSuccess, dispatchInfo?.fireFailure))
    }
  }

  const handleNewUser = async () => {
    let error = false
    if (firstNameMOD === '') {
      NotificationToast(false, 'First name cannot be empty!', true)
      error = true
    }
    if (lastNameMOD === '') {
      NotificationToast(false, 'Last name cannot be empty!', true)
      error = true
    }
    // if (jobTitleMOD === '') {
    //   NotificationToast(false, 'Job title cannot be empty!', true)
    //   error = true
    // }
    if (cellPhoneMOD !== '' && !ValidatePhone(cellPhoneMOD)) {
      NotificationToast(false, 'Invalid office phone!', true)
      error = true
    }
    if (!unitsMOD.length) {
      NotificationToast(false, 'Must select at least one unit!', true)
      error = true
    }
    if (emailAddressMOD === '' || !ValidateEmail(emailAddressMOD)) {
      NotificationToast(false, 'Invalid email address!', true)
      error = true
    }

    if (roleMOD === '') {
      NotificationToast(false, 'Must select a role for this user!', true)
      error = true
    }

    if (!error) {
      // const unitsToAdd = unitsMOD.filter((unitID) => unitID !== unitTree[0].key)
      confirmSaveUser(true, false)
    }
  }

  const handleResetPassword = async (adminPassword, newPassword, confirmPassword) => {
    if (newPassword === confirmPassword) {
      const adminSupervisorID = supervisorID
      const status = await adminUpdateUserPassword(token, accountId, MODsupervisorID, adminSupervisorID, adminPassword, newPassword)

      if (status === true) {
        NotificationToast(false, 'Password updated successfully!')
        setPasswordModal(false)
        return true
      } else {
        NotificationToast(true, 'Incorrect password entered!')
        return false
      }
    } else {
      NotificationToast(true, 'Passwords do not match!')
      return false
    }
  }

  const handleDeleteUser = async (adminPassword) => {
    const adminConfig = {
      adminSupervisorID: supervisorID,
      adminPassword
    }
    dispatch(deleteExistingSupervisor(MODsupervisorID, adminConfig, fireDeleteSuccess, fireDeleteFailure))
  }

  const handleRoleChange = (roleID) => {
    setRoleMOD(roleID)
    // const roleIndex = userRoles.findIndex((userRole) => {
    //   return userRole.roleID === roleID
    // })
    // setRoleNameMOD(userRoles[roleIndex].roleName)
  }

  const handleSaveUser = async (e) => {
    let error = false
    if (firstNameMOD === '') {
      NotificationToast(false, 'First name cannot be empty!', true)
      error = true
    }
    if (lastNameMOD === '') {
      NotificationToast(false, 'Last name cannot be empty!', true)
      error = true
    }
    // if (jobTitleMOD === '') {
    //   NotificationToast(false, 'Job title cannot be empty!', true)
    //   error = true
    // }
    if (cellPhoneMOD !== '' && !ValidatePhone(cellPhoneMOD)) {
      NotificationToast(false, 'Invalid office phone!', true)
      error = true
    }
    if (emailAddressMOD === '' || !ValidateEmail(emailAddressMOD)) {
      NotificationToast(false, 'Invalid email address!', true)
      error = true
    }
    if (!unitsMOD.length) {
      NotificationToast(false, 'Must select at least one unit!', true)
      error = true
    }
    if (roleMOD === '') {
      NotificationToast(false, 'Must select a role for this user!', true)
      error = true
    }

    if (!error) {
      const removingUnitAccess = units.some(ID => !unitsMOD.includes(ID))
      // check if unit access has been removed from the original list
      if (removingUnitAccess) {
        const confirmRemovingAccess = await ConfirmToast({ msg: 'Warning: You are about to remove this supervisor\'s access to one or more organizational units.', txt: 'As a result, any automated alert subscriptions or supervisor group memberships associated with the affected organizational unit(s) will also be removed.' })
        if (!confirmRemovingAccess) { return false }
      }

      if (roleChangeWarning) {
        setRoleChangeAnchorEl(e.currentTarget)
        return false
      }

      confirmSaveUser(false, false, removingUnitAccess)
    }
  }

  const handleUnitClick = (ancestors, key, isSelected, children) => {
    if (!isSelected) {
      const unitsToAdd = []
      let selection = []

      if (!ancestors.length) {
        selection = [key, ...keyify2(children)]
      } else {
        selection = [...ancestors, key, ...keyify2(children)]
      }

      selection.forEach((selectedKey) => {
        if (unitsMOD.findIndex((assignedUnit) => assignedUnit === selectedKey) === -1) {
          unitsToAdd.push(selectedKey)
        }
      })

      setUnitsMOD([...unitsMOD, ...unitsToAdd])
    } else {
      if (ancestors.length) {
        const tempAssigned = [...unitsMOD].filter((assignedUnit) => assignedUnit !== key)
          .filter((assignedUnit) => children.findIndex((childUnit) => childUnit.key === assignedUnit) === -1)

        setUnitsMOD(tempAssigned)
      } else {
        setUnitsMOD([])
      }
    }
  }

  const handleSetUserRole = (e) => {
    setRoleMOD(e.target.value)
    const roleIndex = userRoles.findIndex((userRole) => {
      return userRole.roleID === e.target.value
    })

    if (roleIndex !== -1) {
      const checkRolePermission = userRoles[roleIndex]?.rolePermissions.findIndex(perm => perm.permissionKey === statusPermissions[statusTypes.UNVIEWED])

      if (checkRolePermission !== -1) {
        setRoleChangeWarning(false)
      } else {
        setRoleChangeWarning(true)
      }
    }
  }

  const handleBack = () => {
    setRoleChangeWarning(false)
    handleRoleChangePopClose()
    onBackTrack()
  }

  return (
    <>
      <Grid container direction='column'>
        <Grid container item direction='row' className='mb-3'>
          <Grid item>
            <Button className={classes.greenBtn} variant='contained' onClick={handleBack}>Back</Button>
          </Grid>
        </Grid>

        <Grid container item direction='row'>
          <Grid item>
            <h2 className=''>
              {type === 'edit' ? 'Edit User' : 'Create New User'}
            </h2>
          </Grid>
        </Grid>

        <Grid container item direction='row' className='my-3 w-100 mx-auto' justify='space-evenly'>
          <Grid container item direction='row' xs={8}>
            <Grid container item direction='column' spacing={5}>
              <Grid container item direction='row' spacing={2} className='pr-5 mx-auto w-100'>
                <Grid item xs={6}>
                  <TextField
                    label='First Name'
                    required
                    name='firstName'
                    variant='filled'
                    error={firstNameMOD.length === 0}
                    value={firstNameMOD}
                    onChange={(e) => setFirstNameMOD(e.target.value)}
                    InputProps={{
                      classes: textClasses
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label='Last Name'
                    name='lastName'
                    required
                    variant='filled'
                    error={lastNameMOD.length === 0}
                    value={lastNameMOD}
                    onChange={(e) => setLastNameMOD(e.target.value)}
                    InputProps={{
                      classes: textClasses
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid container item direction='row' spacing={2} className='pr-5 mx-auto w-100'>
                <Grid item xs={6}>
                  <TextField
                    label='Job Title'
                    name='jobTitle'
                    variant='filled'
                    value={jobTitleMOD}
                    onChange={(e) => setJobTitleMOD(e.target.value)}
                    InputProps={{
                      classes: textClasses
                    }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6} container direction='row' alignItems='center' spacing={2} className='mx-auto'>
                  <Grid item xs={10} className='py-0 pl-0 mx-auto'>
                    <FormControl fullWidth>
                      <InputLabel id='multiple-roles-label' variant='filled'>
                        Roles (Select A Role)
                      </InputLabel>
                      <Select
                        labelId='multiple-roles-label'
                        id='multiple-roles'
                        value={roleMOD}
                        variant='filled'
                        classes={selectClasses}
                        // input={<Input id='select-multiple-roles' />}
                        error={roleMOD === ''}
                        MenuProps={MenuProps}
                        onChange={(e) => handleSetUserRole(e)}
                      // renderValue={() => {
                      //   return (
                      //     <div>
                      //       <Chip label={roleNameMOD} className={classes.singleChip} />
                      //     </div>
                      //   )
                      // }}
                      >
                        {roles.map((role, i) => (
                          <MenuItem key={i} value={role.roleID}>
                            {role.roleName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2} container direction='row' justify='center' className='py-0 pr-0 mx-auto'>
                    <Tooltip title='Click to view roles and permissions' placement='top' arrow enterDelay={500}>
                      <IconButton
                        size='medium'
                        className={`${classes.roleBtn} ${roleMOD === '' ? classes.errorLight : classes.successLight}`}
                        onClick={() => setOpenRoles(true)}
                      >
                        <StyleIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item direction='row' spacing={2} className='pr-5 mx-auto w-100'>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor='phone-input' variant='filled'>Office Number</InputLabel>
                    <FilledInput
                      id='phone-input'
                      name='phoneInput'
                      onChange={(e) => setCellPhoneMOD(e.target.value)}
                      value={cellPhoneMOD}
                      error={!ValidatePhone(cellPhoneMOD) && cellPhoneMOD.length !== 0}
                      color='primary'
                      // className={classes.phoneInput}
                      classes={textClasses}
                      fullWidth
                      inputComponent={PhoneMask}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel
                      htmlFor='email-input'
                      variant='filled'
                      required
                    >
                      Email
                    </InputLabel>
                    <FilledInput
                      id='email-input'
                      name='emailInput'
                      onChange={(e) => setEmailAddressMOD(e.target.value)}
                      value={emailAddressMOD}
                      color='primary'
                      required
                      error={!ValidateEmail(emailAddressMOD)}
                      // className={classes.phoneInput}
                      classes={textClasses}
                      fullWidth
                      inputComponent={EmailMask}
                      disabled={type === 'edit'}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              {/* <Grid container item direction='row' spacing={2} className='pr-5 mx-auto w-100'>
                <Grid item xs={6} container direction='row' alignItems='center'>
                  <Tooltip title='Click to add units' placement='top' arrow>
                    <IconButton
                      size='medium'
                      className={`${classes.ouBtn} ${!unitsMOD.length ? classes.errorLight : classes.successLight}`}
                      onClick={manageUnits}
                      onMouseEnter={(e) => setUnitAnchor(e.currentTarget)}
                      onMouseLeave={() => setUnitAnchor(null)}
                    >
                      <AccountTree />
                    </IconButton>
                  </Tooltip>

                  <Popper
                    open={unitAnchor !== null}
                    placement='right-start'
                    anchorEl={unitAnchor}
                    transition
                    className={classes.ouPopper}
                  >
                    {({ TransitionProps }) => (
                      <Fade {...TransitionProps}>
                        <Paper elevation={3} className={classes.ouPaper}>
                          <Grid container item direction='row' justify='center'>
                            <TreeView expanded={expandedKeys}>
                              <UnitTree
                                treeData={unitTree[0].children}
                                onUnitClick={() => { }}
                                selectedKeys={unitsMOD}
                                ancestors={[]}
                              />
                            </TreeView>
                          </Grid>
                        </Paper>
                      </Fade>
                    )}
                  </Popper>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>

          <Grid container item direction='row' xs={4}>
            <Paper elevation={2} className={classes.ouPaper}>
              <Grid container direction='column'>

                <Grid container item direction='row' justify='center' className='mb-2'>
                  <Typography variant='button'>
                    Access Rights
                  </Typography>
                </Grid>

                <Grid container item direction='row'>
                  <TreeView disableSelection expanded={expandedKeys}>
                    <UnitTree
                      treeData={unitTree}
                      onUnitClick={handleUnitClick}
                      selectedKeys={unitsMOD}
                      isCheckbox
                    />
                  </TreeView>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        <Grid container item direction='row' spacing={2} className='mx-auto w-100'>
          {
            type === 'edit'
              ? (
                <>
                  <Grid item xs={4} />

                  <Grid item xs={4} container direction='row' justify='flex-end'>
                    <Button variant='contained' color='secondary' onClick={() => setDeleteModal(true)}>
                      Delete User
                    </Button>
                  </Grid>

                  <Grid item xs={4} container direction='row' justify='flex-end'>
                    <Button variant='contained' color='primary' onClick={handleSaveUser} disabled={openRoleChangeAnchor}>
                      Save
                    </Button>
                  </Grid>

                  {/* <Grid item xs={4} container direction='row' justify='center'>
                    <Button variant='contained' onClick={() => setPasswordModal(true)}>
                      Reset User Password
                    </Button>
                  </Grid> */}
                </>)
              : (
                <Grid item>
                  <Button variant='contained' color='primary' onClick={handleNewUser}>Create User</Button>
                </Grid>)
          }
        </Grid>
        <Popover
          id={openRoleChangeAnchor ? 'confirm-popover' : undefined}
          open={openRoleChangeAnchor}
          anchorEl={roleChangeAnchorEl}
          onClose={handleRoleChangePopClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
        >
          <Grid container direction='column' style={{ padding: '1em' }}>
            <Typography
              style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#3984F7' }}
              gutterBottom
            >
              Heads Up!
            </Typography>

            <Typography
              style={{ fontSize: '1rem', fontWeight: 'bold' }}
              gutterBottom
            >
              This role has restricted permissions. The supervisor may lose access to any subscribed alerts. Are you sure you want to proceed?
            </Typography>

            <Grid
              item
              container
              direction='row'
              justify='flex-end'
              alignItems='center'
              style={{ marginTop: '.5em' }}
            >
              <Button
                style={{
                  marginRight: '.3em',
                  textTransform: 'none',
                  fontWeight: '600',
                  color: '#98B556'
                }}
                onClick={handleRoleChangePopClose}
              >
                Cancel
              </Button>

              <Button
                style={{
                  textTransform: 'none',
                  fontWeight: '600',
                  color: 'white'
                }}
                color='primary'
                variant='contained'
                onClick={() => confirmSaveUser(false, true)}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Popover>
      </Grid>

      <ResetPassword
        passwordModal={passwordModal}
        togglePasswordModal={() => setPasswordModal(false)}
        firstName={firstName}
        lastName={lastName}
        onResetPassword={handleResetPassword}
        passwordCase='admin-case-reset'
      />
      <ResetPassword
        passwordModal={deleteModal}
        firstName={firstName}
        isSSO={isSSO}
        togglePasswordModal={() => setDeleteModal(false)}
        onResetPassword={handleDeleteUser}
        passwordCase='admin-case-delete'
      />

      <Dialog open={openRoles} scroll='paper' disableBackdropClick disableEscapeKeyDown>
        <DialogTitle disableTypography>
          <Grid container direction='row' className='mx-auto w-100' justify='space-between' alignItems='center'>
            <Grid item>
              <Typography variant='h6' className={`${classes.roleTitle}`}>Select a Role</Typography>
            </Grid>
            <Grid item>
              <IconButton className={classes.closeButton} onClick={() => setOpenRoles(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <List className='w-100' disablePadding>
            {
              userRoles
                ? userRoles.map((roleInfo) => {
                  const secondaryText = roleInfo.rolePermissions.reduce((arr, permissionInfo) => {
                    arr.push(permissionInfo.permissionDisplayName)
                    return arr
                  }, [])

                  return (
                    <ListItem button key={`batch-role-${roleInfo.roleID}`} onClick={() => handleRoleChange(roleInfo.roleID)}>
                      <ListItemText
                        primary={
                          <Grid container direction='row' alignItems='center'>
                            <Grid item xs={11}>
                              <Typography variant='body1' component='span' display='block'>
                                {roleInfo.roleName}
                              </Typography>
                            </Grid>

                            <Grid item xs={1} container direction='row' justify='flex-end'>
                              {
                                roleMOD === roleInfo.roleID
                                  ? (
                                    <RadioButtonCheckedIcon className={classes.selectedRole} fontSize='default' />)
                                  : (
                                    <RadioButtonUncheckedIcon className={classes.unselectedRole} fontSize='default' />)
                              }
                            </Grid>
                          </Grid>
                        }
                        disableTypography
                        secondary={
                          <Grid container direction='row' alignItems='center'>
                            <Grid item xs={11}>
                              <Typography variant='body2' component='p' display='block' color='textSecondary' className='mt-2'>
                                {secondaryText.join(', ')}
                              </Typography>
                            </Grid>
                          </Grid>
                        }
                      />
                    </ListItem>
                  )
                })
                : <></>
            }
          </List>
        </DialogContent>
      </Dialog>

      {/* <Dialog open={openUnits} scroll='paper' disableBackdropClick disableEscapeKeyDown>
        <DialogTitle disableTypography>
          <Grid container direction='row' className='mx-auto w-100' justify='space-between' alignItems='center'>
            <Grid item>
              <Typography variant='h6' className={`${classes.roleTitle}`}>Select Units</Typography>
            </Grid>
            <Grid item>
              <IconButton className={classes.closeButton} onClick={() => setOpenUnits(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent className='pl-1'>
          <Grid container direction='row'>
            <Grid container item direction='column'>

              <Grid container item direction='row' justify='center'>
                <TreeView disableSelection expanded={expandedKeys}>
                  <UnitTree
                    treeData={unitTree[0].children}
                    onUnitClick={handleUnitClick}
                    selectedKeys={unitsMOD}
                    ancestors={[]}
                  />
                </TreeView>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog> */}
    </>
  )
}

export default UserMgmtUserMOD
